__turbopack_context__.v({
  "closeButton": "_3S7kHG_closeButton",
  "offerModalTitleRow": "_3S7kHG_offerModalTitleRow",
});
